var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-7531.83,-1545.28)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calendar-black",
    transform: "matrix(0.145417,0,0,0.186342,7128.3,1486.24)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2774.96,
    y: 316.846,
    width: 220.057,
    height: 171.727,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.87679,0,0,5.36648,-49019.8,-7975.88)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7552.07,1551.86L7543.59,1551.86L7543.59,1550.02C7543.59,1549.65 7543.29,1549.35 7542.92,1549.35C7542.55,1549.35 7542.25,1549.65 7542.25,1550.02L7542.25,1551.86L7539.83,1551.86C7538.35,1551.86 7537.16,1553.05 7537.16,1554.53L7537.16,1570.55C7537.16,1572.02 7538.35,1573.22 7539.83,1573.22C7539.83,1573.22 7555.83,1573.22 7555.83,1573.22C7557.3,1573.22 7558.49,1572.02 7558.49,1570.55C7558.49,1570.55 7558.49,1554.53 7558.49,1554.53C7558.49,1553.05 7557.3,1551.86 7555.83,1551.86L7553.4,1551.86L7553.4,1550.02C7553.4,1549.65 7553.1,1549.35 7552.73,1549.35C7552.36,1549.35 7552.07,1549.65 7552.07,1550.02L7552.07,1551.86ZM7557.16,1558.89L7557.16,1570.55C7557.16,1571.28 7556.56,1571.88 7555.83,1571.88L7539.83,1571.88C7539.09,1571.88 7538.49,1571.28 7538.49,1570.55L7538.49,1558.89L7557.16,1558.89ZM7553.4,1553.19L7553.4,1555.03C7553.4,1555.4 7553.1,1555.7 7552.73,1555.7C7552.36,1555.7 7552.07,1555.4 7552.07,1555.03L7552.07,1553.19L7543.59,1553.19L7543.59,1555.03C7543.59,1555.4 7543.29,1555.7 7542.92,1555.7C7542.55,1555.7 7542.25,1555.4 7542.25,1555.03L7542.25,1553.19L7539.83,1553.19C7539.09,1553.19 7538.49,1553.79 7538.49,1554.53L7538.49,1557.56L7557.16,1557.56L7557.16,1554.53C7557.16,1553.79 7556.56,1553.19 7555.83,1553.19L7553.4,1553.19Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.9386b1d9aa00fd296c84c28f8fc73680.svg";
export { ForwardRef as ReactComponent };